import { useEffect, useState } from '@wordpress/element';
import Criterio from '../DicasOtimizacao/AnalisesTextuais/Components/Criterio/Criterio';
import { CustomWarning } from '../../componentsNew/CustomWarning';
import { alert } from '../../componentsNew/CustomWarning/types';
import CarregamentoAnalise from '../DicasOtimizacao/AnalisesTextuais/Components/CarregamentoAnalise';
import {
  useMarkText,
  useUnmark,
} from '../DicasOtimizacao/AnalisesTextuais/Legibilidade/Marcacao/marcacaoHook';
import { useTagsHtmlETexto } from '@hooks/Analises/useManipulacaoDom';
import SemDadosAnalise from './AnalisesTextuais/Components/SemDadosAnalise';
import Typography from '../../componentsNew/Typography';
import { ehTipoLegibilidade } from '@hooks/UtilHooks';

export default function ListaAnalises({
  resultadoAnalises,
  tipo,
  tipoLegibilidade,
  erro = null,
  carregando = false,
  botaoDeslizar = true,
  marcacao = false,
}) {
  const [resultado, setResultado] = useState([]);
  const [criterioSelecionado, setCriterioSelecionado] = useState({});
  const { obterTagsHtmlETextoEditorWp } = useTagsHtmlETexto();

  const { unmark } = useUnmark();

  useEffect(() => {
    if (ehTipoLegibilidade(tipo)) {
      setResultado([]);
    }

    if (resultadoAnalises && resultadoAnalises.length > 0) {
      setResultado(resultadoAnalises);

      let count = 10;
      resultadoAnalises.forEach(item => {
        if (!item.otimizado) count--;
      });
      dispatchEvent(new Event('storage'));
    }
  }, [resultadoAnalises, erro]);

  useEffect(() => {
    if (carregando) {
      setCriterioSelecionado({});
      unmark(obterTagsHtmlETextoEditorWp()?.childNodes || []);
    }
  }, [carregando]);

  return (
    <>
      {carregando && (
        <div className="min-h-[15.438em] items-center justify-center flex">
          <CarregamentoAnalise tipoLegibilidade={tipoLegibilidade} />
        </div>
      )}

      {!ehTipoLegibilidade(tipo) && (
        !carregando &&
        resultado.length == 0 &&
        erro === null && (
          <div className="min-h-[15.438em] items-center justify-center flex h-full">
            <SemDadosAnalise texto="Faça a análise do artigo para obter a avaliação" />
          </div>
        ))}

      {!carregando && erro === null && (
        <>
          {resultado.map(
            (item, index) =>
              item?.titulo &&
              item?.titulo != '' && (
                <Criterio
                  botaoDeslizar={botaoDeslizar}
                  key={item?.titulo}
                  item={item}
                  criterioSelecionado={criterioSelecionado}
                  onChange={() => {
                    let criterioAtivo = criterioSelecionado?.idCriterio == item?.idCriterio;
                    setCriterioSelecionado(l => (l?.idCriterio != item?.idCriterio ? item : {}));
                    if (marcacao) useMarkText(item, !criterioAtivo);
                  }}
                />
              )
            //: !valorCriterio && <CarregamentoAnalise tipoAnalise={item} key={index} />
          )}
        </>
      )}
      {!carregando &&
        erro !== null &&
        !ehTipoLegibilidade(tipo) && (
          <>
            <CustomWarning
              alertType={alert.warning}
              content={
                <div>
                  <Typography className="font-[0.75rem]">{erro}</Typography>
                </div>
              }
            />
          </>
        )}
    </>
  );
}
